import React from 'react'

 const HomeIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="17" height="14.449" viewBox="0 0 17 14.449">
  <path id="Path_13954" data-name="Path 13954" d="M8.8,17.45v-5.1h3.4v5.1h4.25v-6.8H19L10.5,3,2,10.65H4.55v6.8Z" transform="translate(-2 -3)"/>
</svg>


  );
};
export default HomeIcon
